import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { itemsSelector, deviceByIdSelector, coverAttachmentByModelIdSelector } from '../selectors';
import { deleteDiagramItem } from '../actions/entry';
import DeviceDiagram from '../components/Diagram/Device';

const makeMapStateToProps = (state, { elementId, id }) => {
  const items = itemsSelector(state) || [];
  const device = deviceByIdSelector(state, id) || {};
  const attachment = coverAttachmentByModelIdSelector(state, device?.modelId);
  const isError = device.status !== 0;
  return {
    isError,
    elementId,
    device,
    attachment,
    items,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onDelete: deleteDiagramItem,
    },
    dispatch,
  );

export default connect(makeMapStateToProps, mapDispatchToProps)(DeviceDiagram);
